import { render, staticRenderFns } from "./AcademyDialogDisplay.vue?vue&type=template&id=d657c2e6&scoped=true"
import script from "./AcademyDialogDisplay.vue?vue&type=script&lang=js"
export * from "./AcademyDialogDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d657c2e6",
  null
  
)

export default component.exports